import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import './index.scss';

const EquipmentOutModal = ({exit, data}) => {
  const {t} = useTranslation();
  
  return (
    <div className='modal'>
      <div className='modal__content service'>
        <div className='modal__content-head'>
          <p>{t('equipmentOutModal.title')}</p>
        </div>
        <div className='equipmentOut__table'>
          <div className='equipmentOut__table-head'>
            <div className='equipmentOut__table-headTh'>{t('equipmentOutModal.tableHeaders.equipmentSerial')}</div>
            <div className='equipmentOut__table-headTh'>{t('equipmentOutModal.tableHeaders.type')}</div>
            <div className='equipmentOut__table-headTh'>{t('equipmentOutModal.tableHeaders.facility')}</div>
          </div>
          <div className='equipmentOut__table-body'>
            {data?.map((item, index) => {
              return (
                <div className='equipmentOut__table-row' key={index}>
                  <div className='equipmentOut__table-th'>{item?.title}</div>
                  <div className='equipmentOut__table-th'>{item?.type}</div>
                  <div className='equipmentOut__table-th'>{item?.facility}</div>
                </div>
              );
            })}
          </div>
        </div>
        <div className='modal__content-bottom'>
          <button className='save full' onClick={exit}>
            {t('equipmentOutModal.buttons.gotIt')}
          </button>
        </div>
      </div>
      <div className='modal__bg'></div>
    </div>
  );
};

export default EquipmentOutModal;
